<template lang="pug">

  .sosWindow(v-if="show" style="z-index: 202;")

    .sosWindow__inner(style="transform-origin: center center; width: 20%")

      .dialogHeader

        .dialogHeaderTitle
          | Redefinição de senha

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="closeRecoveryWindow")

      form(action="" @submit.prevent="onSubmit" login)

        .dialogBody

          .dialogBodyContent

            p.cardWelcomeTitle.text-left.mt-0.mb-4
              | Receba instruções no seu e-mail para gerar uma nova senha:

            sos-login-field(
              ref="recoveryEmail"
              v-model="recoveryEmail.value"
              name="email"
              type="email"
              placeholder="E-mail"
              buttonIcon="mdi-close"
              :maxLength="128"
              :showSuccess="recoveryEmail.success"
              :showError="recoveryEmail.error"
              :fieldErrors="recoveryEmail.errorMessages"
              :disabled="loading"
              :showButton="String(recoveryEmail.value).length > 0"
              :buttonDisabled="loading"
              @buttonClick="clearRecoveryEmail"
            )

        .dialogFooter.text-right
          sos-button(type="submit" size="medium" buttonLabel="Enviar" buttonIcon="" buttonIconSize="16" :disabled="loading" :loading="loading" full)

</template>

<script>

  //
  //
  //

  import { apiRequestPasswordReset } from '@/services/endpoints/session'

  import { isValidEmail } from '@/mixins/regex.mixin'
  import fieldManagement from '@/constants/loginFieldObject'

  import SosButton from '@/components/SosButton'
  import SosLoginField from '@/components/SosLoginField'


  //
  //
  //
  // Component
  //
  //
  //

  export default {
    name: 'PasswordRecoveryModal',

    components: {
      'sos-button': SosButton,
      'sos-login-field': SosLoginField,
    },

    data: () => ({
      show: false,
      loading: false,
      recoveryEmail: { ...fieldManagement, value: '' },
    }),

    methods: {
      //
      //
      //

      open (email) {
        this.recoveryEmail.value = email
        this.show = true
      },

      closeRecoveryWindow () {
        if (this.loading) return false

        this.loading = false
        this.recoveryEmail = { ...fieldManagement, value: '' }

        this.show = false
      },

      clearRecoveryEmail () {
        this.recoveryEmail.value = ''
      },

      //
      //
      //
      // RECOVERY FORM
      //
      //
      //

      async onSubmit ()
      {
        // CLEAN FIELDS STATUSES

        this.recoveryEmail.setError('')

        // VALIDATE

        const recoveryEmail = String(this.recoveryEmail.value).trim()

        if (!isValidEmail(recoveryEmail)) {
          this.recoveryEmail.setError('Informe um e-mail válido.')
          this.$nextTick(() => { this.$refs.recoveryEmail.triggerBounce() })
          this.$nextTick(() => { this.$refs.recoveryEmail.onFocus() })
          return false
        }

        // RUN

        this.loading = true
        const response = await apiRequestPasswordReset(recoveryEmail)
        this.loading = false

        if (response.httpCode !== 200) {
          this.recoveryEmail.setSuccess(response.message)
        } else {
          this.recoveryEmail.setError(response.message)
        }

        this.$nextTick(() => {
          this.$refs.recoveryEmail.triggerBounce()
          this.$refs.recoveryEmail.onFocus()
        })
      },
    },
  }

</script>
